import { render } from "./Lycee.vue?vue&type=template&id=65fce248&scoped=true"
import script from "./Lycee.vue?vue&type=script&lang=js"
export * from "./Lycee.vue?vue&type=script&lang=js"

import "./Lycee.vue?vue&type=style&index=0&id=65fce248&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fce248"]])

export default __exports__